var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99992 0.833008C4.93731 0.833008 0.833252 4.93706 0.833252 9.99967C0.833252 15.0623 4.93731 19.1663 9.99992 19.1663C15.0625 19.1663 19.1666 15.0623 19.1666 9.99967C19.1666 4.93706 15.0625 0.833008 9.99992 0.833008ZM14.3392 8.08893C14.6646 7.76349 14.6646 7.23586 14.3392 6.91042C14.0137 6.58498 13.4861 6.58498 13.1607 6.91042L8.74992 11.3212L6.83917 9.41042C6.51374 9.08498 5.9861 9.08498 5.66066 9.41042C5.33523 9.73586 5.33523 10.2635 5.66066 10.5889L8.16066 13.0889C8.4861 13.4144 9.01374 13.4144 9.33917 13.0889L14.3392 8.08893Z",
    fill: "#17B26A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.e5f3dc32d0087276251f1d893c617812.svg";
export { ForwardRef as ReactComponent };